import { render } from "./WhatsThis.vue?vue&type=template&id=7f8ea0cd&scoped=true"
import script from "./WhatsThis.vue?vue&type=script&lang=js"
export * from "./WhatsThis.vue?vue&type=script&lang=js"

import "./WhatsThis.vue?vue&type=style&index=0&id=7f8ea0cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8ea0cd"]])

export default __exports__